import { render, staticRenderFns } from "./ProfessionalQualifications.vue?vue&type=template&id=e5dafb02"
import script from "./ProfessionalQualifications.vue?vue&type=script&lang=js"
export * from "./ProfessionalQualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports